import styled from 'styled-components';

import { flexLeftAlignCss } from 'approot/shared/styles/flex.style';
import { rem } from 'approot/shared/style';
import { spacing8 } from 'approot/shared/styles/spacing.style';

export const ExtraConnectionsList = styled.ul`
  ${flexLeftAlignCss}

  flex-wrap: wrap;
  padding: 0;
  list-style: none;
  gap: ${rem(spacing8)};
`;
